import { render, staticRenderFns } from "./Planing.vue?vue&type=template&id=3ead485f&"
import script from "./Planing.vue?vue&type=script&lang=js&"
export * from "./Planing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports